export default {
  subscriptionInfo: null,
  bankAccounts: [],
};
